import { hexToRgbaCss } from 'core/utils/colorHelpers'
import { Components } from '../model'
import {
  defaultAlertComponentStyles,
  defaultBannerComponentStyles,
  defaultCodeComponentStyles,
  defaultGraphComponentStyles,
} from '../serenity/default-components'
import colors from './colors'

const components: Components = {
  frame: {
    // background: colors.grey[100],
    background: '#FAFAFB',
    accentBackground: colors.grey[50],
  },
  header: {
    background: 'transparent',
  },
  sidebar: {
    // background: colors.grey[100],
    background: '#FAFAFB',
    // border: colors.grey[200],
    // activeBackground: colors.red[500],
    // text: colors.grey[650],
    // activeIcon: colors.grey[650],
    // activeText: colors.grey[900],
    // hoverText: colors.grey[900],
    // spinLogoFill: colors.red[500],
    // disabledText: colors.grey[300],
    border: colors.grey[100],
    activeBackground: colors.red[300],
    text: colors.grey[650],
    activeIcon: colors.grey[650],
    activeText: colors.grey[900],
    hoverText: colors.grey[900],
    spinLogoFill: colors.red[500],
  },
  scrollbar: {
    track: 'transparent',
    thumb: colors.grey[300],
  },
  breadcrumb: {
    text: colors.grey[650],
    activeText: colors.grey[900],
    disabledText: colors.grey[300],
    hoverBackground: colors.grey[150],
  },
  tab: {
    text: colors.grey[500],
    activeText: colors.grey[700],
    activeBackground: colors.blue[500],
    border: colors.grey[200],
  },
  tooltip: {
    background: colors.grey[900],
    border: colors.grey[800],
    text: colors.grey['000'],
    copyBackground: colors.grey[600],
  },
  accordion: {
    background: colors.grey[50],
    border: colors.grey[200],
    activeBackground: colors.grey[50],
  },
  wizard: {
    step: {
      bubbleBackground: colors.grey['000'],
      bubbleActiveBackground: colors.blue[500],
      bubbleText: colors.grey[300],
      bubbleActiveText: colors.grey['000'],
      bubbleLabel: colors.grey[500],
      bubbleActiveLabel: colors.grey[700],
      bubbleBorder: colors.grey[200],
    },
    multiStep: {
      bubbleBackground: colors.grey[50],
      bubbleText: colors.grey[600],
      bubbleBorder: colors.grey[200],
    },
  },
  table: {
    background: colors.grey['000'],
    hoverBackground: colors.grey[50],
    border: colors.grey[200],
    headColor: colors.grey[600],
    toolbar: colors.grey['000'],
    toolbarColor: colors.grey[800],
    activeToolbar: colors.grey['000'],
    activeToolbarColor: colors.grey['800'],
    toolbarPassiveColor: colors.grey[300],
  },
  toggleSwitch: {
    activeHandle: colors.blue[700],
    inactiveHandle: colors.grey[500],
    disabledHandle: colors.grey[500],
    activeTrack: hexToRgbaCss(colors.blue[700], 0.1),
    inactiveTrack: colors.grey[200],
    disabledTrack: colors.grey[200],
    label: colors.grey[700],
    hoverLabel: colors.grey[800],
    disabledLabel: colors.grey[300],
  },
  checkbox: {
    border: colors.grey[500],
    background: 'transparent',
    color: colors.grey[700],
    selectedBorder: colors.blue[700],
    selectedBackground: colors.blue[700],
    selectedColor: colors.grey['000'],
    hoverBackground: colors.grey[100],
    disabledBackground: colors.grey[300],
    disabledBorder: colors.grey[300],
    disabledColor: colors.grey[300],
  },
  typography: {
    default: colors.grey[700],
    active: colors.grey[900],
    passive: colors.grey[500],
  },
  iconButton: {
    background: colors.grey['000'],
    border: colors.grey[200],
    color: colors.grey[900],
    activeBackground: colors.grey[50],
    activeBorder: colors.grey[200],
    activeColor: colors.grey[500],
    disabledBackground: colors.grey[100],
    disabledBorder: colors.grey[100],
    disabledColor: colors.grey[300],
    badgeColor: colors.red[500],
    badgeTextColor: colors.grey['000'],
  },
  button: {
    primary: {
      background: colors.blue[500],
      border: colors.blue[500],
      color: colors.grey['000'],
      activeBackground: colors.blue[700],
      activeBorder: colors.blue[700],
      activeColor: colors.grey['000'],
      disabledBackground: colors.grey[300],
      disabledBorder: colors.grey[300],
      disabledColor: colors.grey['000'],
    },
    secondary: {
      background: colors.grey['000'],
      border: colors.grey[150],
      color: colors.grey[750],
      activeBackground: colors.blue[300],
      activeBorder: colors.blue[500],
      activeColor: colors.blue[700],
      disabledBackground: colors.grey[300],
      disabledBorder: colors.grey[300],
      disabledColor: colors.grey['000'],
    },
    tertiary: {
      background: colors.grey[750],
      border: colors.grey[750],
      color: colors.grey['000'],
      activeBackground: colors.grey[700],
      activeBorder: colors.grey[700],
      activeColor: colors.grey['000'],
      disabledBackground: colors.grey[300],
      disabledBorder: colors.grey[300],
      disabledColor: colors.grey['000'],
    },
    cta: {
      // taken from serenityLight.ts. We should remove this later
      background: colors.pink[300],
      border: colors.pink[300],
      color: colors.grey[200],
      activeBackground: colors.pink[500],
      activeBorder: colors.pink[500],
      activeColor: colors.grey['000'],
      disabledBackground: colors.grey[300],
      disabledBorder: colors.grey[300],
      disabledColor: colors.grey['000'],
    },
    text: {
      color: colors.grey[600],
      activeColor: colors.grey[900],
      disabledColor: colors.grey[400],
    },
  },
  input: {
    label: {
      color: colors.grey[700],
      disabled: colors.grey[400],
      hint: colors.grey[400],
    },
    frame: {
      background: colors.grey['000'],
      disabledBackground: 'transparent',
      border: colors.grey[300],
      activeBorder: colors.grey[300],
      color: colors.grey[800],
      placeholder: colors.grey[400],
      disabledPlaceholder: colors.grey[250],
    },
    error: colors.red[500],
    success: colors.blue[500],
  },
  dropdown: {
    background: colors.grey['000'],
    color: colors.grey[700],
    border: colors.grey[300],
    selectedBackground: colors.grey[200],
    activeBackground: colors.grey[200],
    selectedColor: colors.grey[700],
    error: colors.red[500],
  },
  card: {
    background: colors.grey['000'],
    text: colors.grey[700],
    shadow: colors.grey[700],
    border: colors.grey[200],
    passiveText: colors.grey[500],
    activeBackground: colors.blue[200],
    activeBorder: colors.blue[500],
  },
  selectableCard: {
    background: colors.grey['000'],
    text: colors.grey[700],
    shadow: colors.grey[700],
    border: colors.grey[200],
    passiveText: colors.grey[500],
    activeBackground: colors.blue[200],
    activeBorder: colors.blue[500],
  },
  alert: defaultAlertComponentStyles,
  banner: defaultBannerComponentStyles,
  badge: {
    default: {
      color: colors.grey[600],
      background: colors.grey[150],
    },
    primary: {
      color: colors.blue[500],
      background: colors.blue[300],
    },
    secondary: {
      color: colors.teal[700],
      background: colors.teal[300],
    },
    success: {
      color: colors.green[600],
      background: colors.green[300],
    },
    warning: {
      color: colors.yellow[700],
      background: colors.yellow[100],
    },
    unknown: {
      color: colors.grey[600],
      background: colors.grey[100],
    },
    danger: {
      color: colors.orange[700],
      background: colors.orange[300],
    },
    error: {
      color: colors.errorRed[600],
      background: colors.errorRed[200],
    },
  },
  graph: {
    stroke: colors.grey['000'],
    tray: colors.grey[100],
    default: colors.grey[700],
    ...defaultGraphComponentStyles,
  },
  code: defaultCodeComponentStyles,
  stepper: {
    bubbleBackground: colors.grey[100],
    bubbleActiveBackground: colors.blue[500],
    bubbleText: colors.grey[300],
    bubbleActiveText: colors.grey['000'],
    bubbleBorder: colors.grey[100],
    line: colors.grey[100],
  },
}

export default components
